export class CalendarFacadeService {
  registerEvent(): void {
    angular.noop();
  }
  hasPermissions(): void {
    angular.noop();
  }
}



// WEBPACK FOOTER //
// ./app/lib/global/servants/calendar_facade.ts